<script setup>
import CheckCircleIcon from '@iconify-vue/ph/check-circle-fill';
import XCircleIcon from '@iconify-vue/ph/x-circle-fill';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';

const { status, align, toggleCallback } = defineProps({
    status: {
        type: [Boolean, Number, null],
        required: true,
    },
    align: {
        type: String,
        default: 'left',
        required: false,
    },
    toggleCallback: {
        type: Function,
        required: false,
        default: null,
    },
});
</script>

<template>
    <BaseCell :align="align">
        <button
            @click="toggleCallback ? toggleCallback() : null"
            :class="{ 'cursor-pointer': toggleCallback }"
            :disabled="!toggleCallback"
        >
            <CheckCircleIcon v-if="status" class="size-5 text-green-500" />
            <XCircleIcon v-else class="size-5 text-red-500" />
        </button>
    </BaseCell>
</template>
